// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2868": "5472f5c0","3852": "c2ba0910","4137": "ab5e46c2","4817": "1041dec1","6953": "86b3ddf9","8357": "dd422574",}[chunkId] + ".css"
}